import Typography from '@components/Typography';
import {
  TurkTelekomIcon,
  TurkTelekomPrimeIcon,
  TTBusiness,
} from '@assets/icons';

import { Span } from './styled';

export const sharedProps = {
  width: 674,
};

export const PROMOTION_TYPES = {
  TURKTELEKOM: 'turktelekom',
  TTBUSINESS: 'business',
  TTPRIME: 'prime',
};

export const PromotionsConfigs = {
  prime: {
    title: (
      <Typography variant='Title4' color='D400' weight='SemiBold'>
        <span>Türk Telekom Prime </span>
        <Span>Hesap Doğrulama</Span>
      </Typography>
    ),
    Logo: TurkTelekomPrimeIcon,
    promotionTitle: 'Türk Telekom Prime kodunuz yok mu?',
    opening: 'Türk Telekom Prime’ın',
    logoWidth: 110,
    logoHeight: 54,

    promotionCodeLabel: 'Türk Telekom Prime Kodu',
    promotionDescription:
      'Kampanyadan faydalanmak için Türk Telekom mobil uygulaması veya Online İşlemler Bana Özel menüsünden Şifre Al’ı tıklayarak ya da cep telefonunuzdan PRIME SETUR boşluk TCKN yazıp 6262’ye kısa mesaj göndererek şifrenizi alabilirsiniz.',
  },
  turktelekom: {
    title: (
      <Typography variant='Title4' color='D400' weight='SemiBold'>
        <span>Türk Telekom Hesap </span>
        <Span>Doğrulama</Span>
      </Typography>
    ),
    Logo: TurkTelekomIcon,
    promotionTitle: 'Türk Telekom kodunuz yok mu?',
    opening: 'Türk Telekom’la',
    logoWidth: 150,
    logoHeight: 50,
    promotionCodeLabel: 'Türk Telekom Kodu*',
    promotionDescription:
      'Kampanyadan faydalanmak için Bi’ Dünya Fırsat mobil uygulaması üzerinden veya Online İşlemler Bana Özel menüsünden Şifre Al’ı tıklayarak ya da cep telefonunuzdan SETUR boşluk TCKN yazıp 6262’ye kısa mesaj göndererek şifrenizi alabilirsiniz.',
  },
  business: {
    title: (
      <Typography variant='Title4' color='D400' weight='SemiBold'>
        <span>Türk Telekom Prime</span>
        <Span>Business Hesap Doğrulama</Span>
      </Typography>
    ),
    Logo: TTBusiness,
    promotionTitle: 'Türk Telekom Business kodunuz yok mu?',
    opening: 'Türk Telekom Prime Business’ın',
    logoWidth: 122,
    logoHeight: 74,
    promotionCodeLabel: 'Türk Telekom Business Kodu',
    promotionDescription: (
      <>
        Kampanyadan faydalanmak için Türk Telekom mobil uygulaması veya Online
        İşlemler Bana Özel menüsünden Şifre Al’ı tıklayarak ya da cep
        telefonunuzdan <strong>yaz</strong> otelleri kampanyası için
        <strong> SETUR YAZ </strong>
        yazıp 7227’ye kısa mesaj göndererek şifrenizi alabilirsiniz.
      </>
    ),
  },
};

export type Promotion = keyof typeof PromotionsConfigs;
